<div class="section-title">Alert Log for {{asset.asset_name}}</div>

@if (pageLogs === undefined) {
<div class="loading-status">
	<div class="logo-spin"></div>
	Loading alerts...
</div>
}

@if (pageLogs && !pageLogs.length) {
<div class="loading-status">
	No alerts have been recorded for this asset
</div>
}

@if (pageLogs && pageLogs.length > 0) {
<table class="log compact" [class.loading]="pageLoading">
	<thead>
		<tr>
			<th>Date</th>
			<th>Component</th>
			<th>Summary</th>
			<th>Acknowledged</th>
			@if (api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master') {
			<th>
				Delete</th>
			}
		</tr>
	</thead>
	@for (alert of pageLogs; track alert) {
	<tbody>
		<tr>
			<td>{{alert.timestamp | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0) }}</td>
			<td>{{alert.component_name}}</td>
			<td class="truncate" [title]="alert.description"><span>{{alert.description}}</span></td>
			<td>
				@if (alert.ack_by) {
				<div [title]="alert.ack_timestamp | datetime : 'offset' : (fleet ? fleet.time_offset_hours : 0)">
					{{alert.ack_email}}
					@if (this.api.user.role !== 'readonly') {
					<app-action-button [action]="UnacknowledgeAlert" [args]="[alert.alert_id]" [context]="this" title="Undo acknowledgement" btnClass="icon small"
						confirm="Undo acknowledgement?" processing="..."><i class="icon-minus-circled"></i></app-action-button>
					}
				</div>
				}
				@if (!alert.ack_by) {
				<app-action-button [disabled]="this.api.user.role === 'readonly'" [action]="PromptAcknowledge" [args]="[alert.alert_id]" [context]="this" btnClass="green compact"
					processing="...">Acknowledge</app-action-button>
				}
			</td>
			@if (api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master') {
			<td>
				<app-action-button [action]="DeleteAlert" [args]="[alert.alert_id]" [context]="this" title="Delete alert" btnClass="icon red" confirm="Delete this alert completely?"
					processing="..."><i class="icon-trash"></i></app-action-button>
			</td>
			}
		</tr>
		@if (alert.ack_note) {
		<tr>
			<td [attr.colspan]="(api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master') ? 5 : 4" class="alert-note">
				{{alert.ack_note}}
			</td>
		</tr>
		}
	</tbody>
	}
</table>
<ngb-pagination [collectionSize]="totalAlerts" [pageSize]="alertItemsPerPage" [(page)]="alertCurrentPage" (pageChange)="alertUpdatePage()" [maxSize]="10" [directionLinks]="true"
	[rotate]="true"></ngb-pagination>
<div class="alert-actions">
	<app-action-button [action]="ExportAlerts" [context]="this" processing="Exporting...">
		Download Alert Data <i class="green leftpad icon-download"></i></app-action-button>
	<app-action-button [action]="AcknowledgeAll" [context]="this" btnClass="green" processing="Acknowledging..." complete="All alerts acknowledged">
		Acknowledge All</app-action-button>
</div>
}

<ng-template #ackNoteModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Acknowledgement notes</h4>
		<button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body">
		<div class="mb-3">Enter a note</div>
		<form>
			<div class="mb-3">
				<input [(ngModel)]="acknowledgingNote" name="acknowledgingNote" type="text" class="form-control" ngbAutofocus>
			</div>
			<app-action-button submit [action]="AcknowledgeAlert" [context]="this" btnClass="green" processing="...">
				Acknowledge</app-action-button>
		</form>
	</div>
</ng-template>